import { render } from "./CardReview.vue?vue&type=template&id=db14ef0c"
import script from "./CardReview.vue?vue&type=script&lang=js"
export * from "./CardReview.vue?vue&type=script&lang=js"

import "./CardReview.vue?vue&type=style&index=0&id=db14ef0c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__